import React from "react";
import { Box, Icon, type IconProps } from "@chakra-ui/react";

export function CursorIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        fill="#fff"
        stroke="#191A1C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.947 8.341c.609-.236.913-.355.999-.522a.494.494 0 0 0-.006-.46c-.09-.166-.397-.276-1.012-.497L2.24 1.231c-.503-.18-.755-.271-.92-.214a.494.494 0 0 0-.304.305c-.057.164.033.416.214.92l5.63 15.686c.222.615.332.922.497 1.012.143.078.316.08.46.006.168-.085.287-.39.523-.999l2.564-6.592c.046-.12.07-.18.105-.23a.494.494 0 0 1 .116-.115c.05-.035.11-.059.229-.105l6.592-2.564Z"
      />
    </Icon>
  );
}
